import {
  service
} from '@/utils/request'
// var outUrl = 'http://apitest.ibabygroup.cn'
export default {
  //获取所有栏目
  getAllColumn: () => {
    return service({
      url: '/cloud/dvoice/v1/column/all',
      method: 'get',
    })
  },
  //获取数量
  getCount: (params) => {
    return service({
      url: '/cloud/dvoice/v1/column/column/post/cnt',
      method: 'get',
      params: params
    })
  },
  //增加栏目
  addNewColumn: (data) => {
    return service({
      url: '/cloud/dvoice/v1/column/add',
      method: 'post',
      data: data
    })
  },
  //编辑栏目
  editColumn: (data) => {
    return service({
        url: '/cloud/dvoice/v1/column/modify',
        method: 'post',
        data: data
      }) 
  },
  //删除栏目
  deteleColumn: (path) => {
    return service({
        url: '/cloud/dvoice/v1/column/del' + path,
        method: 'get',
      }) 
  },
}



// WEBPACK FOOTER //
// ./src/api/contentManage/columnManage.js